module.exports = __webpack_public_path__ + "static/img/xcx_code.ba245f78.png";